query GetEmoteWallDataById($emoteWallId: ID!, $slug: String) {
  emoteWall: StreamToolsGetEmoteWallDataById(emoteWallId: $emoteWallId, slug: $slug) {
    channels {
      channelLogin
      broadcasterUserId
    }
    config {
      emoteWallId
      name
      style
      emoteSize
      density
      durationSeconds
      showTwitchEmotes
      show7tvEmotes
      showBttvEmotes
      showFfzEmotes
      youtubeChatChannels
      blockedWords
    }
    youtubeEmojiChannel
  }
}
